export default __webpack_public_path__ + "static/media/cara-kerja-2.86c733c1.png";